import React, { FCC } from 'react'

import { Pill, CrossIcon } from './DiscountPill.styles'

interface DiscountPillProps {
  value: string
  onDeleteClick?: () => void
}

const DiscountPill: FCC<DiscountPillProps> = ({ value, onDeleteClick }) => {
  return (
    <Pill>
      <span>{value}</span>
      <CrossIcon data-testid="remove-discount-button" onClick={onDeleteClick} />
    </Pill>
  )
}

export default DiscountPill
